{
    "ControlsAgentButtonTitle": "Mostrar todos os controles disponíveis para o agente",
    "ControlsDeviceButtonTitle": "Mostrar todos os controles disponíveis para o dispositivo",
    "NAME": "StaticAgentControls"
}